/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetUsersProfileQueryResponse, GetUsersProfile400 } from '../entities/GetUsersProfile'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUsersProfile } from '../api/getUsersProfile'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersProfileQueryKey = () => [{ url: '/users/profile' }] as const

export type GetUsersProfileQueryKey = ReturnType<typeof getUsersProfileQueryKey>

export function getUsersProfileQueryOptions(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getUsersProfileQueryKey()
  return queryOptions<GetUsersProfileQueryResponse, ResponseErrorConfig<GetUsersProfile400>, GetUsersProfileQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getUsersProfile(config)
    },
  })
}

/**
 * @description Получение профиля пользователя
 * @summary Получение профиля пользователя
 * {@link /users/profile}
 */
export function useGetUsersProfile<
  TData = GetUsersProfileQueryResponse,
  TQueryData = GetUsersProfileQueryResponse,
  TQueryKey extends QueryKey = GetUsersProfileQueryKey,
>(
  options: {
    query?: Partial<QueryObserverOptions<GetUsersProfileQueryResponse, ResponseErrorConfig<GetUsersProfile400>, TData, TQueryData, TQueryKey>> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getUsersProfileQueryKey()

  const query = useQuery(
    {
      ...(getUsersProfileQueryOptions(config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUsersProfile400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}